import type { StateDeclarationFn } from './types';

export default (function () {
  return [
    {
      parent: 'tpa',
      abstract: true,
      name: 'social-groups',
      url: '?',
      params: {
        'social-groups-ooi-override': {
          squash: true,
          type: 'string',
          value: '',
        },
        'version-tag-override': {
          squash: true,
          type: 'string',
          value: '',
        },
        petri_ovr: {
          squash: true,
          type: 'string',
          value: '',
        },
      },
    },
  ];
} as StateDeclarationFn);
